import React from "react";
import { BaseDialogModalWindow } from "@/components/modules/Post/BaseDialogModalWindow";

export const WarningDialogModalWindow: React.FC<{
  title: string;
  text?: string;
  isOpen: boolean;
  button: React.ReactNode;
  onClose: () => void;
}> = ({ title, text, isOpen, button, onClose }) => {
  return (
    <BaseDialogModalWindow isOpen={isOpen} onClose={onClose}>
      <h3 className="mb-[8px] font-mercury text-xl font-semibold text-dark">{title}</h3>
      <div className="mb-[24px]">
        <p className="font-body font-light text-dark-70">{text}</p>
      </div>
      <div className="flex w-full flex-col gap-[16px] md:flex-row">
        <div className="w-full overflow-hidden rounded-full" onClick={onClose}>
          {button}
        </div>
      </div>
    </BaseDialogModalWindow>
  );
};
